module.exports = __webpack_public_path__ + "c4e6637f467dd4c147e6a43623e89297.pdf";